import { render, staticRenderFns } from "./AgendarReserva.vue?vue&type=template&id=40a63192&"
import script from "./AgendarReserva.vue?vue&type=script&lang=js&"
export * from "./AgendarReserva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports